module.exports = __webpack_public_path__ + "static/media/idlingCity.4812f1c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Idling/idlingCity.svg
// module id = 926
// module chunks = 0